// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowOutCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-out-circle': IconArrowOutCircle;
    }
}

/**
 * The icon component for the 'arrowOutCircle' icon
 */
export class IconArrowOutCircle extends IconSvg {
    public constructor() {
        super(arrowOutCircle16X16);
    }
}

registerIconSvg('icon-arrow-out-circle', IconArrowOutCircle);
export const iconArrowOutCircleTag = 'nimble-icon-arrow-out-circle';
